import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';

/**
 * for this page
 */
import Header from './header';
import Footer from '../../components/footer';

import Content from './content';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        window.addEventListener(
            'message',
            event => {
                if (event?.data?.rjhPath) {
                    window.open(`https://finance.ifeng.com/hkSub?iframeUrl=${event.data.rjhPath}`, 'target', '');
                }
            },
            false,
        );
    }

    state = {};

    render() {
        const { content } = this.props;

        const headerData = {
            nav: content.nav,
            topAd: content.topAd,
            search: content.search,
            logo: content.logo,
            mainNavData: content.mainNavData,
        };

        const contentData = {
            secondNavData: content.secondNavData,
            leftNavData: content.leftNavData,
        };

        const footerData = content.footer;

        return (
            <div className={styles.layout}>
                <Header content={headerData} />
                <Content content={contentData} />
                <Footer content={footerData} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
